<template>
    <div>
        <!-- Breadcrumb Section Start -->
        <section class="breadscrumb-section pt-0">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="breadscrumb-contain">
                            <h2>{{ $t('Contact us') }}</h2>
                            <nav>
                                <ol class="breadcrumb mb-0">
                                    <li class="breadcrumb-item active" aria-current="page">{{ $t('Contact us') }}</li>
                                    <li class="breadcrumb-item">
                                        <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                            <i class="fa-solid fa-house"></i>
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Breadcrumb Section End -->

        <!-- Contact Box Section Start -->
        <section class="contact-box-section">
            <div class="container-fluid-lg">
                <div class="row g-lg-5 g-3">
                    <div class="col-lg-6">
                        <div class="left-sidebar-box mb-2">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="contact-image">
                                        <img src="/theme/assets/images/inner-page/contact-us.png"
                                             class="img-fluid blur-up lazyloaded" alt="">
                                    </div>
                                </div>
                                <div class="col-xl-12">
                                    <div class="contact-title">
                                        <h3>
                                            {{ $t('Contact Information') }}
                                        </h3>
                                    </div>

                                    <div class="contact-detail">
                                        <div class="row g-4">

                                            <div class="col-xxl-6 col-lg-12 col-sm-6"
                                                 v-for="data in contact_data?.data" :key="item.id" >
                                                <a class="contact-detail-box" :href="data?.href">
                                                    <div class="contact-icon">
                                                        <i :class="data?.icon"></i>
                                                    </div>
                                                    <div class="contact-detail-title">
                                                        <h4>{{ data?.type }}</h4>
                                                    </div>

                                                    <div class="contact-detail-contain">
                                                        <p>{{ data?.value }}</p>
                                                    </div>
                                                </a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="title d-xxl-none d-block">
                            <h2>
                                {{ $t('Contact us')}}
                            </h2>
                        </div>
                        <div class="right-sidebar-box mb-2">
                            <form @submit.prevent="create">
<!--                            <alertErrors :errors="validationErrors" v-if="validationErrors"></alertErrors>-->

                                <div class="alert alert-danger" v-if="error_message !== null">
                                    {{ error_message }}
                                </div>

                                <div class="row">
                                    <div class="col col-12">
                                        <div class="mb-md-4 mb-3 custom-form">
                                            <label for="name" class="form-label">{{ $t('Name') }}</label>
                                            <div class="custom-input" :class="{ 'is-invalid' : isInvalid('name')}">

                                                <input type="text" id="name" class="form-control" v-model="item.name">
                                                <i class="fa-solid fa-signature"></i>
                                            </div>
                                            <div class="invalid-feedback" v-if="isInvalid('name')">
                                                {{  isInvalid('name') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xxl-6 col-lg-12 col-sm-6">
                                        <div class="mb-md-4 mb-3 custom-form">
                                            <label for="purpose" class="form-label">{{ $t('Purpose of connection') }}</label>
                                            <div class="custom-input" :class="{ 'is-invalid' : isInvalid('purpose')}">

                                                <select class="form-control" id="purpose" v-model="item.purpose">
                                                    <option value="" selected="" disabled="" hidden="" style="display: none;"></option>
                                                    <option v-for="(value,key) in form_options?.purpose" :value="key" >{{ value }}</option>
                                                </select>
                                                <i class="fa-regular fa-handshake"></i>
                                            </div>

                                            <div class="invalid-feedback" v-if="isInvalid('purpose')">
                                                {{  isInvalid('purpose') }}
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-xxl-6 col-lg-12 col-sm-6">
                                        <div class="mb-md-4 mb-3 custom-form">
                                            <label for="importance" class="form-label"> {{ $t('Importance of communication') }}</label>
                                            <div class="custom-input"  :class="{ 'is-invalid' : isInvalid('importance')}" >

                                                <select class="form-control" id="importance" v-model="item.importance">
                                                    <option value="" selected="" disabled="" hidden="" style="display: none;"></option>
                                                    <option v-for="(value,key) in form_options?.importance" :value="key" >{{ value }}</option>
                                                </select>

                                                <i class="fa-solid fa-handshake"></i>
                                            </div>
                                            <div class="invalid-feedback" v-if="isInvalid('importance')">
                                                {{  isInvalid('importance') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xxl-6 col-lg-12 col-sm-6">
                                        <div class="mb-md-4 mb-3 custom-form">
                                            <label for="email" class="form-label"> {{ $t('Email') }}</label>
                                            <div class="custom-input" :class="{ 'is-invalid' : isInvalid('email')}">

                                                <input type="email" dir="ltr" id="email" class="form-control" v-model="item.email">
                                                <i class="fa-solid fa-envelope"></i>
                                            </div>
                                            <div class="invalid-feedback" v-if="isInvalid('email')">
                                                {{  isInvalid('email') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xxl-6 col-lg-12 col-sm-6">
                                        <div class="mb-md-4 mb-3 custom-form">
                                            <label for="phone" class="form-label"> {{ $t('Phone') }}</label>
                                            <div class="custom-input" :class="{ 'is-invalid' : isInvalid('phone')}">

                                                <input type="tel" dir="ltr"  id="phone" class="form-control" v-model="item.phone">
                                                <i class="fa-solid fa-phone"></i>
                                            </div>
                                            <div class="invalid-feedback" v-if="isInvalid('phone')">
                                                {{  isInvalid('phone') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col col-12 ">
                                        <div class="mb-md-4 mb-3 custom-form">
                                            <label for="message" class="form-label"> {{ $t('Message') }}</label>
                                            <div class="custom-input" :class="{ 'is-invalid' : isInvalid('message')}">

                                                <textarea v-model="item.message" id="message" class="form-control" ></textarea>
                                                <i class="fa-solid fa-message"></i>
                                            </div>
                                            <div class="invalid-feedback" v-if="isInvalid('message')">
                                                {{  isInvalid('message') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <button type="submit" class="btn btn-animation btn-md fw-bold ms-auto">
                                    {{ $t('Send Message')}}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Contact Box Section End -->

    </div>
</template>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();

import alertErrors from "../handling/alert-errors";

export default {
    components: {
        alertErrors,
    },
    data() {
        return {
            contact_data: [],
            form_options: {},
            item: {},
            validationErrors: null,
            error_message: null,
        }
    },
    created() {


        const id = toast.info(this.$t('getting options ...'),{ icon: 'fa-light fa-filter-list'  });

        const that = this;

        axios.get('contact_us/create').then(response => {
            toast.dismiss(id);
            this.form_options = response.data.elements;
        }) .catch(function (error) {
            toast.dismiss(id);
            if (error.response) {
                that.validationErrors = error.response.data.errors ;
            }
        });

        this.getResults();


    },
    methods: {
        isInvalid( name ) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        getResults () {
            const id = toast.info(this.$t('Getting content ...'),{ icon: 'fa-solid fa-download' });
            axios.get('contacts_data').then(response => {
                toast.dismiss(id);
                this.contact_data = response.data;
            }, response => {
                toast.dismiss(id);
            });
        },
        create() {

            const id = toast.info(this.$t('Adding content...'),{ icon: 'fa-solid fa-cloud-arrow-up'  });

            const that = this;
            this.validationErrors = null;
            this.error_message = null;


            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });

            axios.post('contact_us',
                formData
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message  ,{
                    timeout: 3000,
                },{ icon: 'fa-solid fa-circle-check'  });

                this.item = {};
                this.$router.push({name: 'home', params: { lang : this.$i18n.locale }});

            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors ;
                    that.error_message = error.response.data.message ;
                    toast.error(error.response.data.message  ,{
                        timeout: 3000,
                    },{ icon: 'fa-solid fa-circle-exclamation'  });
                }
            });

        }
    }
}
</script>
